import type { ModuleNavItem } from '@confluent/shared/modules';
import { clientModuleRegistry } from './registry.js';
import { useEnabledModules } from './useEnabledModules.js';

export interface NavItemWithModule extends ModuleNavItem {
  moduleId: string;
}

/**
 * Returns a flat list of all nav items from enabled modules, in navOrder order.
 * Does NOT apply policy filtering — callers do that themselves.
 *
 * Returns an empty array while the enabled-modules query is still loading.
 */
export function useAllEnabledNavItems(): NavItemWithModule[] {
  const { data: enabledManifests = [] } = useEnabledModules();

  const enabledIds = new Set(enabledManifests.map((m) => m.id));
  const enabledModules = clientModuleRegistry.filter(enabledIds);

  return enabledModules.flatMap((mod) => mod.manifest.nav.map((item) => ({ ...item, moduleId: mod.manifest.id })));
}
